import { render } from "./watch_index.vue?vue&type=template&id=00ed8c2e"
import script from "./watch_index.vue?vue&type=script&lang=js"
export * from "./watch_index.vue?vue&type=script&lang=js"

import "./watch_index.vue?vue&type=style&index=0&id=00ed8c2e&lang=css"

import exportComponent from "/Users/wanfeng/code/userBehavior-course/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__